import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Divider, Button, Icon, Popconfirm, message, Row, Col} from 'antd';
import axios from 'axios';
import LeaveRequestDialogForm from './LeaveRequestForm'
import Moment from 'react-moment';
import moment from 'moment';
import { workingDaysCount } from './leaveUtil';
import { fetchHolidays } from './LeaveService';
import { getLeaveType } from '../../components/LeaveType/LeaveTypeService'

const API_HOST_URL = process.env.REACT_APP_API_URL

class MyLeaveRequest extends Component{
  
  state = {
    datalist: [],
    filteredDataList: [],
    leaveRequest: {},
    visible: false,
    requestType: '',
    confirmLoading: false
  }

  componentDidMount(){
    this.fetchData();
  }

  columns = [
    {
      title: 'From',
      dataIndex: 'fromDate',
      key: 'fromDate',
      render: (record) => (
        // <Moment format="DD/MM/YYYY">
        //     <span>{record}</span>
        // </Moment>
        moment(record).format('ll')
      )
      
    },
    {
      title: 'To',
      dataIndex: 'toDate',
      key: 'toDate',
      render: (record) => (
        // <Moment format="DD/MM/YYYY">
        //     <span>{record}</span>
        // </Moment>
        moment(record).format('ll')
      )
    },
    {
      title: 'Day(s)',
      // dataIndex: 'amount',
      key: 'amount',
      render: (record) => (
      <span>
        {
          record.amount + (record.amount > 1 ? ' days': ' day')
            // this.leaveDuration(record.amount)
        }
      </span>   
    )
    },
    {
      title: 'Reason',
      dataIndex: 'note',
      key: 'note'
    },
    {
      title: 'Leave Type',
      dataIndex: 'leaveType.leaveType',
      key: 'leaveType'
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   key: 'status'
    // },
    {
      title: 'Status',
      // dataIndex: 'action',
      key: 'status',
      render: (record) => (
            <span style={{color: record.status === 'Approved' && record.status!=='Pending'? 'green': (record.status === 'Denied'?'red':'black') }}>
              {record.status}
            </span>
      )
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   fixed: 'right',
    //   width: 100,
    //   render: (record) => (
    //     <span>
    //       {
    //         record.status === 'Pending' ?
    //         <span>
    //           <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>

    //           <Divider type="vertical" />

    //           {this.state.datalist.length >= 1
    //             ? (
    //               <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
    //                 <a href="javascript:;"><Icon type="delete" /></a>
    //               </Popconfirm>
    //           ) : null}
    //         </span>
    //         :
    //         ''
    //       }
    //       </span>
    //   ),

    // }
  ];

  leaveDuration(hours){
    let days = 0;
    let eightHourDay_hours = 0;
    let extraHours = 0;
    if(hours >= 8 ){
      console.log("Postive hours "+ hours);
      eightHourDay_hours = (8 * hours)/24;
      days = Math.trunc(eightHourDay_hours/8);
      extraHours = Math.trunc(eightHourDay_hours % 8)
      return days + (days>1?' days':' day') + ', ' + extraHours  + (extraHours>1?' hours':' hour')
    } else {
      extraHours = hours;
      return extraHours + (extraHours>1?' hours':' hour')
    } 
  }

  fetchData = () => {
    // /?employee=32&expand=employee&expand=leaveType
    axios.get(`${API_HOST_URL}/api/leave/leaverequest/?expand=employee&expand=leaveType&employee=${this.props.loggedInEmployee.id}`)
      .then(res => {
        this.setState({
          // datalist: res.data
          datalist: res.data
        })
      })
  }


  handleCreate = async() =>{
    const form = this.formRef.props.form;
    const requestType = this.state.requestType;
    const selectedLeaveTypeId = this.formRef.props.form.getFieldValue('leaveType');
    let workingDays = 0;
    const holidays = await fetchHolidays();
    const leaveType = await getLeaveType(selectedLeaveTypeId);

    form.validateFields((err, values) => {
      
      if(leaveType.countWeekends === true && leaveType.countHolidays === true){
        workingDays = moment(values.toDate).diff(values.fromDate, 'days') + 1;
      } else {
        workingDays = workingDaysCount(values.fromDate, values.toDate, holidays);
        console.log("working days _ to be saved to server: ", workingDays)
      }


      if (err) {
        return;
      } else if (workingDays <= 0){
        message.error("You can't apply for 0 days or less");
      } else if(moment(values.fromDate).isAfter(moment(values.toDate))){
        message.error("Please change 'from Date' to be before 'to Date' !");
      } else {
      this.setState({
        confirmLoading: true
      })

     

      console.log("Employee Id: ", this.props.loggedInEmployee.id)
      switch( requestType ){
        case 'post':
            return axios.post(`${API_HOST_URL}/api/leave/leaverequest/`, {
              fromDate: values.fromDate,
              toDate: values.toDate,
              amount:  workingDays,//this.workingDaysCount(values.fromDate, values.toDate),//moment(values.toDate).diff(values.fromDate, 'days'),
              note: values.note,
              leaveType: values.leaveType,
              employee: this.props.loggedInEmployee.id
            })
            .then(res => {
              console.log(res)
              form.resetFields();
              this.setState({ visible: false, confirmLoading: false });
              this.fetchData();
              message.success('Leave request submitted successfully!');
        })
            .catch(error => {
              console.log(error.response.data);
              if(error.response.data.hasOwnProperty('non_field_errors')){
                
                  message.error(error.response.data.non_field_errors[0]);
              
              } else message.error(JSON.stringify(error.response.data));
            });

        case 'put':
            return axios.put(`${API_HOST_URL}/api/leave/leaverequest/${this.state.leaveRequest.id}/`, {
              fromDate: values.fromDate,
              toDate: values.toDate,
              amount: workingDays,//this.workingDaysCount(values.fromDate, values.toDate),//moment(values.toDate).diff(values.fromDate, 'days'),
              note: values.note,
              leaveType: values.leaveType,
              employee: this.props.loggedInEmployee.id
            })
                .then(res => {
                  console.log(res)
                  form.resetFields();
                  this.setState({ visible: false, confirmLoading: true });
                  this.fetchData()
                  message.success('Leave request submitted successfully!');
            })
                .catch(error =>{
                  console.log(error.response.data);
                  if(error.response.data.hasOwnProperty('non_field_errors')){
                    
                      message.error(error.response.data.non_field_errors[0]);
                  
                  } else message.error(JSON.stringify(error.response.data));
                });
                
        default: return;
      }
    }
    });
  }

  handleEdit = record => {
      this.setState({leaveRequest: record});
      this.showModal('put');
  }

  handleDelete = (record) => {
    const datalist = [...this.state.datalist];

    return axios.delete(`${API_HOST_URL}/api/leave/leaverequest/${record.id}/`)
                .then(res => {
                  console.log(res)

                  this.setState({ visible: false });
                  this.fetchData()
            })
                .catch(error => console.err(error));
  }

  showModal = (type) => {
    if( type === 'post'){
      //no data should be passed to dialog form
      this.setState({leaveRequest: {}});
    }

    this.setState({ visible: true, requestType: type });
  }

  handleCancel = () => {
    this.setState({ visible: false, confirmLoading: false });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('request_for_leave') > -1 ? 
            <Button type="primary" onClick={() => this.showModal('post')}> Apply for Leave</Button>
            : ''
            }

            {
              this.props.userPermissions.indexOf('access_my_leave') > -1 ? 
            <Table columns={this.columns} dataSource={this.state.datalist} rowKey="id" scroll={{ x: '100%' }}/>
            : 'You do not have rights to access your leave requests. Please contact your administrator'
            }

            <LeaveRequestDialogForm
              wrappedComponentRef={this.saveFormRef}
              visible={this.state.visible}
              onCancel={this.handleCancel}
              onCreate={this.handleCreate}
              data={this.state.leaveRequest}
              confirmLoading={this.state.confirmLoading}/>
        </div>
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    loggedInEmployee: state.loggedInEmployee,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(MyLeaveRequest);
